import React from "react";
import { Form } from "antd";
import { dateParser } from "../../utils/parsers";
import { DATE_FORMAT, DATE_DATA_FORMAT } from "../../../../../utils/date";
import { DatePicker } from "@tailormed/common-client/component/DatePicker";

export default ({ required = false, placeholder = DATE_FORMAT, defaultDate = null, ...props }) => (
  <Form.Item
    rules={[{ type: "date" }, { required }]}
    getValueProps={dateParser}
    getValueFromEvent={(momentValue) => momentValue?.format(DATE_DATA_FORMAT)}
    {...props}
  >
    <DatePicker placeholder={placeholder} defaultPickerValue={defaultDate} />
  </Form.Item>
);
